// extracted by mini-css-extract-plugin
export default {"cardContentWrap":"styles_cardContentWrap__-3Vzv"};